module.exports = __webpack_public_path__ + "static/media/7_James_R@2x.42d9271c.jpg";